module.exports = __webpack_public_path__ + "img/40-10c66e.png";